import React from 'react';
import { Box } from '@mui/material';
import FilterChip from './FilterChip';
import { ABOUT_TYPES } from '../../../constants/assignmentStatuses';

// Color helper functions for about types
export const getAboutTypeColors = (aboutType) => {
  const isAboutMe = aboutType === ABOUT_TYPES.ABOUT_ME;
  
  return {
    backgroundColor: isAboutMe ? '#DCFCE7' : '#FEF2F2',
    textColor: isAboutMe ? '#166534' : '#991B1B',
    borderColor: isAboutMe ? '#22C55E' : '#EF4444'
  };
};

const AboutType = ({ 
  selectedAboutTypes = [], 
  onAboutTypeToggle,
  sx = {} 
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', ...sx }}>
      {Object.values(ABOUT_TYPES).map((aboutType) => {
        const isSelected = selectedAboutTypes.includes(aboutType);
        const colors = getAboutTypeColors(aboutType);
        
        return (
          <FilterChip
            key={aboutType}
            label={aboutType}
            isSelected={isSelected}
            onClick={() => onAboutTypeToggle(aboutType)}
            backgroundColor={colors.backgroundColor}
            textColor={colors.textColor}
            borderColor={colors.borderColor}
            showDot={true}
          />
        );
      })}
    </Box>
  );
};

export default AboutType; 